import { Component, Vue } from "vue-property-decorator";

@Component
export default class agreement extends Vue {
	onClickLeft(){
		history.go(-1);
	}
}
